(function ($) {
  Drupal.behaviors.mppproductlayout = {
    attach: function (context) {
      var $mpp_layouts = $('.js-mpp-container', context);

      $mpp_layouts.each(function (i, obj) {
        var $mpp = $(obj);
        var $gridWrappers = $('.product-grid-wrapper', $mpp);
        var $grids = $('.js-product-grid', $mpp);
        var $sorter = $('.js-mpp-sort', $mpp);
        var $sorterLabel = $('.js-mpp-sort-label', $mpp);
        var $filter = $('.js-mpp-filter-sets', $mpp);
        var $filterContainer = $('.js-mpp-filter', $mpp);
        var $sortfilterContainer = $('.js-mpp-sort-filter', $mpp);
        var $itemCountContainer = $('.js-grid-item-count-container', $mpp);
        var $itemCountSpan = $('.js-grid-count-total', $mpp);
        var $filterToggle = $('.js-filter-toggle', $mpp);

        // capture sort selection events and tell grid to sort
        $mpp.on('mpp-sort:selected', function (e, val) {
          $(document).trigger('mpp-sort', [val]);
          $grids.trigger('mantle-grid:sort-selected', [val]);
        });

        // capture sort selection events and tell grid to sort
        $filter.on('filterset:filter-set', function (e, filterstring) {
          $(document).trigger('mpp-filter');
          $grids.trigger('mantle-grid:filter-set', [filterstring]);
        });

        $filter.on('filterset:reset', function () {
          $(document).trigger('mpp-filter-reset');
          $grids.trigger('mantle-grid:filter-reset');
        });

        $grids.on('mantle-grid:grid-count', function (e, gridCountInfo) {
          var gridCount = gridCountInfo.products;

          $itemCountContainer.attr('data-grid-count', gridCount);
          $itemCountSpan.text(gridCount);
          $itemCountContainer.each(function (i, obj) {
            var $container = $(obj);

            if (!$container.data('item-count-template')) {
              return; // continue
            }

            var itemCountTemplate = $container.data('item-count-template');
            var itemCountData = {
              item_count: gridCount
            };

            if (gridCount === 1) {
              itemCountData.single = true;
            }
            // eslint-disable-next-line no-undef
            var itemCountContent = Mustache.render(itemCountTemplate, itemCountData);

            $container.html(itemCountContent);
          });
        });

        $filterToggle.on('click', function () {
          $mpp.toggleClass('filters-open');
          var opened = $mpp.hasClass('filters-open');
          var breakpoints = Unison.fetch.all();
          var bPmediumUp = parseInt(breakpoints.medium, 10);

          if (opened) {
            $('body').addClass('filters-open');
            if ($filterContainer.length > 0) {
              // wait for animation
              window.setTimeout(function () {
                if ($(window).width() >= bPmediumUp) {
                  return;
                }
                var coords = $filterContainer[0].getBoundingClientRect();
                var scrollTop = $(window).scrollTop();
                var window_bottom = scrollTop + coords.bottom + 50;

                $('body').css('height', window_bottom);
              }, 700);
            }
          } else {
            $('body').removeClass('filters-open');
            $('body').css('height');
          }
        });

        $sorterLabel.on('click', function () {
          $mpp.toggleClass('sorter-open');
          var opened = $mpp.hasClass('sorter-open');

          if (opened) {
            $('body').addClass('sorter-open');
            if ($sortfilterContainer.length > 0) {
              // wait for animation
              window.setTimeout(function () {
                if ($(window).width() >= 768) {
                  return;
                }
                var coords = $sortfilterContainer[0].getBoundingClientRect();
                var scrollTop = $(window).scrollTop();
                var window_bottom = scrollTop + coords.bottom + 50;

                $('body').css('height', window_bottom);
              }, 700);
            }
          } else {
            $('body').removeClass('sorter-open');
            $('body').css('height');
          }
        });

        /*
         * Run Product Grid Init
         */
        var $sortLinks = $('[data-sort-key][data-default="1"]', $sorter);

        if ($sortLinks.length) {
          $grids.attr('data-sort-string', $sortLinks.data('sort-key'));
        }
        $gridWrappers.each(function (i, obj) {
          Drupal.behaviors.productGrid.forceProcessTarget(obj);
        });

        // force running below after drupal behaviors have all attached.
        $(function () {
          var filter_manifest = $filter.triggerHandler('filterset:request-filter-manifest');
          var all_filter_sets = $grids.triggerHandler('mantle-grid:process-filter-manifest', [filter_manifest]);

          $filter.trigger('filterset:init', [all_filter_sets]);

          $grids.trigger('mantle-grid:request-grid-count');
        });
      });
    }
  };
})(jQuery);
